import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';

interface FormFooterProps {
	primaryButtonLabel: any;
	secondaryButtonLabel: any;
	secondaryClickHandler: any;
	mode: string;
}

const FormFooter: React.FC<FormFooterProps> = (props) => {
	const { primaryButtonLabel, secondaryButtonLabel, secondaryClickHandler, mode } = props;
	const [css] = useStyletron();

	return (
		<footer
			className={css({
				display: 'flex',
				justifyContent: 'flex-end'
			})}>
			<div className={css({ display: 'flex', width: '200px', justifyContent: 'space-between', margin: '50px 100px 100px 0' })}>
				{mode !== 'view' && (
					<Button kind='primary' type='submit'>
						{' '}
						{primaryButtonLabel}{' '}
					</Button>
				)}
				<Button kind='secondary' onClick={secondaryClickHandler}>
					{' '}
					{secondaryButtonLabel}{' '}
				</Button>
			</div>
		</footer>
	);
};

export default FormFooter;
